<div class="filter-wrapper" *ngIf="filters.length !== 0">
  <span class="chips-label">{{ 'label.filteredBy' | translate | async }}</span>
  <app-dismissible-chip
    *ngFor="let filter of filters"
    class="filter"
    [chipItem]="filter"
    (dismissed)="filterRemoved.emit($event)">
  </app-dismissible-chip>
</div>
